module.exports = __webpack_public_path__ + "img/chrome.df4fc1f5.png";